import { gql } from 'graphql-request';
import { merchantServiceGraphql, tokenAppGraphql, userToken } from '../config/Config';

export const getMerchantId = async (id) => {
  try {
    const SUBMERCHANT = gql`
      query SubMerchant($subMerchantId: Int!) {
        SubMerchant(id: $subMerchantId) {
          merchantID
        }
      }
    `;
    const variables = {
      subMerchantId: id,
    };
    const respone = await merchantServiceGraphql.request(
      SUBMERCHANT,
      variables
    );
    return respone.SubMerchant.merchantID;
  } catch (err) {
    return null;
  }
};

export const updateStatusSubMerchant = async (data, password) => {
  const UPDATE_STATUS_SUBMERCHANT = gql`
  mutation UpdateStatusSubMerchant($updateStatusSubMerchantId: Int!, $status: Int!) {
    updateStatusSubMerchant(id: $updateStatusSubMerchantId, status: $status) {
      id
      status
    }
  }
  `;

  const requestHeaders = {
    authorization: userToken,
    Password: password
  };

  const response = await tokenAppGraphql.request(UPDATE_STATUS_SUBMERCHANT, data, requestHeaders);
  return response.updateStatusSubMerchant;
}

export const getAllSubMerchant = async () => {
  const GET_ALL_SUBMERCHANT = gql`
  query AllSubMerchants {
    allSubMerchants {
      id
      merchantID
      submerchantID
      name
    }
  }
  `

  const response = await merchantServiceGraphql.request(GET_ALL_SUBMERCHANT);
  return response
}

export const getSubmerchantInfo = async (id) => {
  const GET_SUBMERCHANT_INFO = gql`
    query SubMerchant($subMerchantId: Int!) {
      SubMerchant(id: $subMerchantId) {
        name
        id
        merchantID
      }
    }
  `;
  const variables = {
    subMerchantId: id,
  };
  const response = await merchantServiceGraphql.request(
    GET_SUBMERCHANT_INFO,
    variables
  );
  return response.SubMerchant;
};

export const createSubMerchant = async (data) => {
  try {
    const CREATE_SUBMERCHANT = gql`
      mutation Mutation(
        $merchantID: Int!
        $phone: String!
        $email: String!
        $address: String!
        $submerchantID: Int
        $name: String
        $zip: String
        $state: Int
        $city: Int
        $bankAccount: String
      ) {
        createSubMerchant(
          merchantID: $merchantID
          phone: $phone
          email: $email
          address: $address
          submerchantID: $submerchantID
          name: $name
          zip: $zip
          state: $state
          city: $city
          bank_account: $bankAccount
        ) {
          id
          submerchantID
          merchantID
          name
          zip
          state
          city
          phone
          email
          address
          bank_account
          status
          created_at
          updated_at
        }
      }
    `;
    const respone = await merchantServiceGraphql.request(
      CREATE_SUBMERCHANT,
      data
    );
    return respone.createSubMerchant;
  } catch (err) {
    return null;
  }
};
